import React from 'react';  // eslint-disable-line

const Video = (props) => {
    return (
        <svg width="14px" height="16px" viewBox="0 0 14 16" version="1.1" xmlns="http://www.w3.org/2000/svg">
            <title>play</title>
            <g id="Admin-CMS" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="custom-content-video-2" transform="translate(-402.000000, -585.000000)">
                    <g id="Icon-/-Media-Play" transform="translate(397.000000, 581.000000)">
                        <polygon id="Shape" points="0 0 24 0 24 24 0 24" />
                        <path d="M7.26250681,19.7895835 L18.2624806,13.289599 C19.2437099,12.7114753 19.2468532,11.2864909 18.2624806,10.7083673 L7.26250681,4.20523951 C6.36874063,3.67713408 5,4.18961455 5,5.49588585 L5,18.4989676 C5,19.6708398 6.27187807,20.377076 7.26250681,19.7895835 Z" id="play" fill={props.color !== null ? props.color : '#616B7D'} />
                    </g>
                </g>
            </g>
        </svg>
    );
};

export default Video;
